<template>
    <div>
        <validation-observer ref="editClinicianRules">
            <b-form
                class="px-2"
            >
                <b-row cols="12">
                    <b-col md="8">
                        <!-- date month and date year -->
                        <b-row>
                            <b-col md="12">
                                <b-form-group
                                    label="Clinician Name"
                                >
                                    <b-form-input
                                        :value="userData.agency + ' · ' + userData.firstName + ' ' + userData.lastName"
                                        readonly
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="7">
                                <validation-provider
                                    #default="{ errors }"
                                    name="Claim Date Month"
                                    rules="required"
                                >
                                    <b-form-group
                                        label-for="Claim Date Month"
                                        :state="errors.length > 0 ? false:null"
                                    >
                                    <template v-slot:label>
                                        Claim Date Month <span class="text-danger">*</span>
                                    </template>
                                        <v-select
                                            v-model="claimDateMonth"
                                            placeholder="Claim Date Month"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsMonths"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                        />
                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col md="5">
                                <validation-provider
                                    #default="{ errors }"
                                    name="Claim Date Year"
                                    rules="required"
                                >
                                    <b-form-group
                                        label-for="Claim Date Year"
                                        :state="errors.length > 0 ? false:null"
                                    >
                                    <template v-slot:label>
                                        Claim Date Year <span class="text-danger">*</span>
                                    </template>
                                        <v-select
                                            v-model="claimDateYear"
                                            placeholder="Claim Date Year"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsYears"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                        />
                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <b-col md="12" class="px-0" v-if="programClinician !== 'PGRC - OASAS Program'">
                            <validation-provider
                                #default="{ errors }"
                                name="Client"
                                rules="required"
                            >
                                <b-form-group
                                    label-for="Client"
                                    :state="errors.length > 0 ? false:null"
                                >
                                <template v-slot:label>
                                    Client <span class="text-danger">*</span>
                                </template>
                                    <v-select
                                        v-model="client"
                                        placeholder="Client"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        :options="optionsClient"
                                        label="label"
                                        :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                    />
                                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>

                        <b-row v-if="programClinician === 'PGRC - OASAS Program' || programClinician === 'PGRC - Private Practitioner'">
                            <b-col md="6">
                                <b-form-group
                                    label-for="Date Of Birth"
                                >
                                <template v-slot:label>
                                    Date Of Birth <span class="text-danger">*</span>
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Date Of Birth"
                                        rules="required"
                                    >
                                        <date-picker
                                            v-model="dateOfBirthPGRCOASASProgram"
                                            placeholder="Select a Date"
                                            type="date"
                                            format="MMM DD, Y"
                                            value-type="MM-DD-YYYY"
                                            style="max-width: 100% !important; width: 100% !important;"
                                            :state="errors.length > 0 ? false:null"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                        ></date-picker>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <validation-provider
                                    #default="{ errors }"
                                    name="Sex at birth"
                                    rules="required"
                                >
                                    <b-form-group
                                        label-for="Sex at birth"
                                        :state="errors.length > 0 ? false:null"
                                    >
                                    <template v-slot:label>
                                        Sex at birth <span class="text-danger">*</span>
                                    </template>
                                        <v-select
                                            v-model="sexAtBirth"
                                            placeholder="Sex at birth"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionssexAtBirth"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                        />
                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col md="6">
                                <b-form-group
                                    label-for="Last 4 SSN"
                                >
                                <template v-slot:label>
                                    Last 4 SSN <span class="text-danger">*</span>
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="Last 4 SSN"
                                        rules="required"
                                    >
                                        <b-form-input
                                            v-model="last4SSN"
                                            trim
                                            placeholder="Last 4 SSN"
                                            :state="errors.length > 0 ? false:null"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group
                                    label-for="First Two Letters of Last Name (Birth Name)"
                                >
                                <template v-slot:label>
                                    First Two Letters of Last Name (Birth Name) <span class="text-danger">*</span>
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="First Two Letters of Last Name (Birth Name)"
                                        rules="required"
                                    >
                                        <b-form-input
                                            v-model="firstTwoLettersLastName"
                                            trim
                                            placeholder="First Two Letters of Last Name (Birth Name)"
                                            :state="errors.length > 0 ? false:null"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div>
                            <b-form
                                ref="formRepeaterSessions"
                                class="repeater-form"
                                @submit.prevent="repeateAgain"
                            >
                                <b-col cols="12">
                                    <hr>
                                </b-col>
                                <!-- Row Loop -->
                                <b-row
                                    v-for="(item, index) in itemsFormRepeater"
                                    :id="item.id"
                                    :key="item.id"
                                    ref="row"
                                >
                                    <b-col cols="12">
                                        <h5>Session # {{index + 1}}</h5>
                                    </b-col>
                                    <!-- Date of session -->
                                    <b-col md="6">
                                        <validation-provider
                                            #default="{ errors }"
                                            :name="`Day of Session`"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Day of Session"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Day of Session <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="item.dayOfSession"
                                                    placeholder="Day of Session"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsDay"
                                                    :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                                    class="selectDaySession"
                                                    autocomplete="on"
                                                    @keyup.native="changeClaimDateMonth(item.id)"
                                                    :style="!validFormRepeater && !item.dayOfSession ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <!-- Type of session -->
                                    <b-col md="6">
                                        <span style="display: none !important;">
                                            {{ typeSession = item.typeOfSession }}
                                            {{ howConducted = item.howConducted }}
                                            {{ remoteOption = item.remoteOption }}
                                            {{ amountCompany = item.amount }}
                                            {{ amountCopay = item.copayAmount }}
                                            {{ amountSliding = item.enterAmmountInsuranceCompanyPay  }}
                                        </span>
                                        <validation-provider
                                            #default="{ errors }"
                                            :name="`Type of Session`"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Type of Session"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Type of Session <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="item.typeOfSession"
                                                    placeholder="Type of Session"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsTypeOfSession"
                                                    :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                                    :style="!validFormRepeater && !item.typeOfSession ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <!-- Length of session -->
                                    <b-col md="6">
                                        <validation-provider
                                            #default="{ errors }"
                                            :name="`Length of Session`"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Length of Session"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Length of Session <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="item.lengthOfSession"
                                                    placeholder="Length of Session"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsLengthOfSession"
                                                    :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                                    :style="!validFormRepeater && !item.lengthOfSession ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <!-- How Conducted -->
                                    <b-col md="6">
                                        <validation-provider
                                            #default="{ errors }"
                                            :name="`How Conducted`"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="How Conducted"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                How Conducted <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="item.howConducted"
                                                    placeholder="How Conducted"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsHowConducted"
                                                    :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                                    :style="!validFormRepeater && !item.howConducted ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <!-- Remote Option -->
                                    <b-col md="6" v-if="item.howConducted === 'Remote'">
                                        <validation-provider
                                            #default="{ errors }"
                                            :name="`Remote Option`"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Remote Option"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Remote Option <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="item.remoteOption"
                                                    placeholder="Remote Option"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsRemoteOption"
                                                    :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                                    :style="!validFormRepeater && !item.remoteOption ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <!-- Is insurance utilized for session -->
                                    <b-col md="6">
                                        <validation-provider
                                            #default="{ errors }"
                                            :name="`Is insurance reimbursing for session?`"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Is insurance reimbursing for session?"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Is insurance reimbursing for session? <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="item.isInsuranceUtilizedForSession"
                                                    placeholder="Is insurance reimbursing for session?"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsIsInsuranceUtilizedForSession"
                                                    :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                                    :style="!validFormRepeater && !item.isInsuranceUtilizedForSession ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <!-- Options if insurance utilized for claim is: YES -->
                                    <b-col md="6" v-if="item.isInsuranceUtilizedForSession === 'Yes'">
                                        {{item.isInsuranceUtilizedForSession === 'Yes' ? item.nameOfInsuranceCompany = '' : null}}
                                        <b-form-group
                                            label-for="Enter name of insurance company"
                                        >
                                        <template v-slot:label>
                                            Enter name of insurance company
                                        </template>
                                            <!-- <validation-provider
                                                #default="{ errors }"
                                                :name="`Enter name of insurance company`"
                                                rules="required"
                                            > -->
                                                <b-form-input
                                                    v-model="item.nameOfInsuranceCompany"
                                                    trim
                                                    placeholder="Enter name of insurance company"
                                                    :disabled="true"
                                                    :style="!validFormRepeater && !item.nameOfInsuranceCompany ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                />
                                                <!-- <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider> -->
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6" v-if="item.isInsuranceUtilizedForSession === 'Yes'">
                                        {{item.isInsuranceUtilizedForSession === 'Yes' ? item.enterAmmountInsuranceCompanyPay = '' : null}}
                                        <b-form-group
                                            label-for="Enter amount insurance company will pay for session"
                                        >
                                        <template v-slot:label>
                                            Enter amount insurance company will pay for session
                                        </template>
                                            <!-- <validation-provider
                                                #default="{ errors }"
                                                :name="`Enter amount insurance company will pay for session`"
                                                rules="required"
                                            > -->
                                                <cleave
                                                    v-model="item.enterAmmountInsuranceCompanyPay"
                                                    class="form-control"
                                                    :raw="false"
                                                    :options="options.block"
                                                    placeholder="Enter amount insurance company will pay for session"
                                                    :disabled="true"
                                                    :style="!validFormRepeater && item.enterAmmountInsuranceCompanyPay === '' ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                />
                                                <!-- <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider> -->
                                        </b-form-group>
                                    </b-col>
                                    <!-- Options if insurance utilized for claim is: NO -->
                                    <b-col :md="item.ifNotUtilizingInsuranceSession === 'Other' ? '6' : '6'" v-if="item.isInsuranceUtilizedForSession === 'No'">
                                        {{item.isInsuranceUtilizedForSession === 'No' ? item.ifNotUtilizingInsuranceSession = '' : null}}
                                        <!-- <validation-provider
                                            #default="{ errors }"
                                            :name="`If insurance is not reimbursing, select reason why`"
                                            rules="required"
                                        > -->
                                            <b-form-group
                                                label-for="If insurance is not reimbursing, select reason why"
                                            >
                                            <template v-slot:label>
                                                If insurance is not reimbursing, select reason why
                                            </template>
                                                <v-select
                                                    v-model="item.ifNotUtilizingInsuranceSession"
                                                    placeholder="If insurance is not reimbursing, select reason why"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsIfNotUtilizingInsurance"
                                                    :disabled="true"
                                                    :style="!validFormRepeater && !item.ifNotUtilizingInsuranceSession ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                />
                                                <!-- <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback> -->
                                            </b-form-group>
                                        <!-- </validation-provider> -->
                                    </b-col>
                                    <b-col md="6" v-if="item.ifNotUtilizingInsuranceSession === 'Other' && item.isInsuranceUtilizedForSession === 'No'">
                                        {{item.isInsuranceUtilizedForSession === 'No' ? item.ifNotUtilizingInsuranceSessionResponseOther = '' : null}}
                                        <b-form-group
                                            label-for="If no, please explain"
                                        >
                                        <template v-slot:label>
                                            If no, please explain
                                        </template>
                                            <!-- <validation-provider
                                                #default="{ errors }"
                                                :name="`If no, please explain`"
                                                rules="required"
                                            > -->
                                                <b-form-input
                                                    v-model="item.ifNotUtilizingInsuranceSessionResponseOther"
                                                    trim
                                                    placeholder="If no, please explain"
                                                    :disabled="true"
                                                    :style="!validFormRepeater && !item.ifNotUtilizingInsuranceSessionResponseOther ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                />
                                                <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                                            <!-- </validation-provider> -->
                                        </b-form-group>
                                    </b-col>

                                    <b-col :md="item.didClientProvideCopay === 'Yes' ? '6' : '6'">
                                        {{item.isInsuranceUtilizedForSession === 'Yes' ? item.didClientProvideCopay = '' : null}}
                                        <b-form-group
                                            label-for="Did client provide copay?"
                                            v-if="item.isInsuranceUtilizedForSession === 'No'"
                                        >
                                        <template v-slot:label>
                                            Did client provide copay?
                                        </template>
                                            <v-select
                                                v-model="item.didClientProvideCopay"
                                                placeholder="Did client provide copay?"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                :options="optionsDidClientProvideCopay"
                                                :disabled="true"
                                                :style="'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                            />
                                        </b-form-group>
                                        <!-- <validation-provider
                                            #default="{ errors }"
                                            :name="`Did client provide copay?`"
                                            rules="required"
                                            v-else
                                        > -->
                                            <b-form-group
                                                label-for="Did client provide copay?"
                                                v-else
                                            >
                                            <template v-slot:label>
                                                Did client provide copay?
                                            </template>
                                                <v-select
                                                    v-model="item.didClientProvideCopay"
                                                    placeholder="Did client provide copay?"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsDidClientProvideCopay"
                                                    :disabled="true"
                                                    :style="!validFormRepeater && !item.didClientProvideCopay ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                />
                                                <!-- <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback> -->
                                            </b-form-group>
                                        <!-- </validation-provider> -->
                                    </b-col>
                                    <b-col md="6" v-if="item.didClientProvideCopay === 'Yes'">
                                        {{item.isInsuranceUtilizedForSession === 'Yes' ? item.copayAmount = '' : null}}
                                        <b-form-group
                                            label-for="Copay Amount"
                                        >
                                        <template v-slot:label>
                                            Copay Amount
                                        </template>
                                            <!-- <validation-provider
                                                #default="{ errors }"
                                                :name="`Copay Amount`"
                                                rules="required"
                                            > -->
                                                <b-form-input
                                                    v-model="item.copayAmount"
                                                    trim
                                                    placeholder="Copay Amount"
                                                    autofocus
                                                    :disabled="true"
                                                    :style="!validFormRepeater && item.copayAmount === '' ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : item.isInsuranceUtilizedForSession === 'Yes' ? 'background: #efefef; background-color: #efefef; cursor: no-drop;' : 'background: #efefef; background-color: #efefef; cursor: no-drop;'"
                                                />
                                                <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                                            <!-- </validation-provider> -->
                                        </b-form-group>
                                    </b-col>
                                    
                                    <b-col :md="item.didClientUtilizeSlidingScale === 'Yes' ? '6' : '6'">
                                        <validation-provider
                                            #default="{ errors }"
                                            :name="`Did client utilize sliding scale?`"
                                            rules="required"
                                        >
                                            <b-form-group
                                                label-for="Did client utilize sliding scale?"
                                                :state="errors.length > 0 ? false:null"
                                            >
                                            <template v-slot:label>
                                                Did client utilize sliding scale? <span class="text-danger">*</span>
                                            </template>
                                                <v-select
                                                    v-model="item.didClientUtilizeSlidingScale"
                                                    placeholder="Did client utilize sliding scale?"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="optionsDidClientUtilizeSlidingScale"
                                                    :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                                    :style="!validFormRepeater && !item.didClientUtilizeSlidingScale ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                />
                                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                                    {{ errors[0] }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </validation-provider>
                                    </b-col>
                                    <b-col md="6" v-if="item.didClientUtilizeSlidingScale === 'Yes'">
                                        <b-form-group
                                            label-for="Amount"
                                        >
                                        <template v-slot:label>
                                            Amount <span class="text-danger">*</span>
                                        </template>
                                            <validation-provider
                                                #default="{ errors }"
                                                :name="`Amount`"
                                                rules="required"
                                            >
                                                <b-form-input
                                                    v-model="item.amount"
                                                    trim
                                                    :state="errors.length > 0 ? false:null"
                                                    placeholder="Amount"
                                                    autofocus
                                                    :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                                    :style="!validFormRepeater && item.amount === '' ? 'border: 1px solid #ea5455 !important; border-radius: 0.357rem !important;' : ''"
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                    <!-- Subtotal billed to PGRC -->
                                    <span style="display: none">
                                        {{ item.didClientUtilizeSlidingScale === 'No' ? item.amount = 0 : null }}
                                        
                                        {{ item.isInsuranceUtilizedForSession === 'Yes' ? item.subtotalBilledToPGRC = '$'+(0).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '15 minutes' ? item.subtotalBilledToPGRC = '$'+((group15Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '30 minutes' ? item.subtotalBilledToPGRC = '$'+((group30Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '45 minutes' ? item.subtotalBilledToPGRC = '$'+((group45Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '60 minutes' ? item.subtotalBilledToPGRC = '$'+((group60Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '75 minutes' ? item.subtotalBilledToPGRC = '$'+((group75Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '90 minutes' ? item.subtotalBilledToPGRC = '$'+((group90Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '15 minutes' ? item.subtotalBilledToPGRC = '$'+((individual15Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '30 minutes' ? item.subtotalBilledToPGRC = '$'+((individual30Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '45 minutes' ? item.subtotalBilledToPGRC = '$'+((individual45Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '60 minutes' ? item.subtotalBilledToPGRC = '$'+((individual60Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '75 minutes' ? item.subtotalBilledToPGRC = '$'+((individual75Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '90 minutes' ? item.subtotalBilledToPGRC = '$'+((individual90Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.subtotalBilledToPGRC = '$'+(0).toFixed(2) }}

                                        {{ item.isInsuranceUtilizedForSession === 'Yes' ? subtotalPGRCobserver = '$'+(0).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '15 minutes' ? subtotalPGRCobserver = '$'+((group15Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '30 minutes' ? subtotalPGRCobserver = '$'+((group30Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '45 minutes' ? subtotalPGRCobserver = '$'+((group45Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '60 minutes' ? subtotalPGRCobserver = '$'+((group60Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '75 minutes' ? subtotalPGRCobserver = '$'+((group75Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : item.typeOfSession === 'Group' && item.lengthOfSession === '90 minutes' ? subtotalPGRCobserver = '$'+((group90Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '15 minutes' ? subtotalPGRCobserver = '$'+((individual15Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '30 minutes' ? subtotalPGRCobserver = '$'+((individual30Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '45 minutes' ? subtotalPGRCobserver = '$'+((individual45Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '60 minutes' ? subtotalPGRCobserver = '$'+((individual60Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '75 minutes' ? subtotalPGRCobserver = '$'+((individual75Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : (item.typeOfSession === 'Individual' || item.typeOfSession === 'Assessment' || item.typeOfSession === 'Couple' || item.typeOfSession === 'Family') && item.lengthOfSession === '90 minutes' ? subtotalPGRCobserver = '$'+((individual90Min) - (parseFloat(item.amount ? item.amount : 0) + parseFloat(item.copayAmount ? item.copayAmount : 0) + parseFloat(item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay : 0))).toFixed(2) : subtotalPGRCobserver = '$'+(0).toFixed(2) }}

                                        {{ item.subtotalBilledToPGRC ? calculateAmountBilledToCFE() : null }}
                                    </span>
                                    <b-col md="6">
                                        <b-form-group
                                            label="Subtotal billed to PGRC"
                                            label-for="Subtotal billed to PGRC"
                                        >
                                            <b-form-input
                                                v-model="item.subtotalBilledToPGRC"
                                                trim
                                                placeholder="Subtotal billed to PGRC"
                                                readonly
                                                :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                            />
                                        </b-form-group>
                                    </b-col>

                                    <!-- Remove Button -->
                                    <b-col
                                        cols="12"
                                        class="mb-1"
                                    >
                                        <b-button
                                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                            variant="outline-danger"
                                            class="mt-0 mt-md-2"
                                            @click="removeItem(index)"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                        >
                                            <feather-icon
                                                icon="XIcon"
                                                class="mr-25"
                                            />
                                            <span>Delete</span>
                                        </b-button>
                                    </b-col>
                                    <b-col cols="12">
                                        <hr>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </div>
                        <!-- add session button -->
                        <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="mb-1 p-50"
                            @click="repeateAgain"
                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                        >
                            <feather-icon
                                icon="PlusIcon"
                                class="mr-50"
                            />
                            <span class="align-middle">Add Session</span>
                        </b-button>

                        <b-col md="12" class="px-0">
                            <validation-provider
                                #default="{ errors }"
                                name="Client Progress This Month"
                                rules="required"
                            >
                                <b-form-group
                                    label-for="Client Progress This Month"
                                    :state="errors.length > 0 ? false:null"
                                >
                                <template v-slot:label>
                                    Client Progress This Month <span class="text-danger">*</span>
                                </template>
                                    <v-select
                                        v-model="clientProgressThisMonth"
                                        placeholder="Client Progress This Month"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        :options="optionsClientProgressThisMonth"
                                        :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                    />
                                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <!-- <b-row class="px-10"> -->
                            <!-- <b-col :md="clientReportsSatisfactionWithTreatmentSessions === 'No' ? '8' : '12'">
                                <validation-provider
                                    #default="{ errors }"
                                    name="Client Reports Satisfaction with Treatment Sessions"
                                    rules="required"
                                >
                                    <b-form-group
                                        label-for="Client Reports Satisfaction with Treatment Sessions"
                                        :state="errors.length > 0 ? false:null"
                                    >
                                    <template v-slot:label>
                                        Client Reports Satisfaction with Treatment Sessions <span class="text-danger">*</span>
                                    </template>
                                        <v-select
                                            v-model="clientReportsSatisfactionWithTreatmentSessions"
                                            placeholder="Client Reports Satisfaction with Treatment Sessions"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="optionsClientReportsSatisfactionWithTreatmentSessions"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                        />
                                        <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
                            </b-col> -->
                            <!-- <b-col md="4" v-if="clientReportsSatisfactionWithTreatmentSessions === 'No'">
                                <b-form-group
                                    label-for="If no, please explain"
                                >
                                <template v-slot:label>
                                    If no, please explain <span class="text-danger">*</span>
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="If no, please explain"
                                        rules="required"
                                    >
                                        <b-form-input
                                            v-model="ifNoReportsSatisfaction"
                                            trim
                                            placeholder="If no, please explain"
                                            autofocus
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                            :state="errors.length > 0 ? false:null"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col> -->
                        <!-- </b-row> -->
                        <b-col md="12" class="px-0">
                            <b-form-group
                                label="Amount Billed to PGRC"
                            >
                                <b-form-input
                                    v-model="amountBilledToCFE"
                                    trim
                                    placeholder="Amount Billed to PGRC"
                                    readonly
                                />
                            </b-form-group>
                        </b-col>
                    </b-col>

                    <!-- RIGHT CONTENT -->
                    <b-col md="4">
                        <b-form-group
                            label="Notes"
                        >
                            <b-form-textarea
                                id="textarea-default"
                                placeholder="Notes"
                                rows="3"
                                v-model="notes"
                                :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                            />
                        </b-form-group>

                        <b-row class="mt-3">
                            <b-col md="4">
                                <b-form-group
                                    label-for="# of Individual In-Person Sessions"
                                >
                                <template v-slot:label>
                                    # of Individual In-Person Sessions
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="# of Individual In-Person Sessions"
                                        rules="required"
                                    >
                                        <cleave
                                            v-model="noIndividualSessions"
                                            class="form-control"
                                            :raw="false"
                                            :options="options.block"
                                            placeholder="# of Individual In-Person Sessions"
                                            :state="errors.length > 0 ? false:null"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                            readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                    label-for="# of Group Sessions"
                                >
                                <template v-slot:label>
                                    # of Group Sessions
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="# of Group Sessions"
                                        rules="required"
                                    >
                                        <cleave
                                            v-model="noGroupSessions"
                                            class="form-control"
                                            :raw="false"
                                            :options="options.block"
                                            placeholder="# of Group Sessions"
                                            :state="errors.length > 0 ? false:null"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                            readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                    label-for="# of Remote Sessions"
                                >
                                <template v-slot:label>
                                    # of Remote Sessions
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="# of Remote Sessions"
                                        rules="required"
                                    >
                                        <cleave
                                            v-model="noRemoteSessions"
                                            class="form-control"
                                            :raw="false"
                                            :options="options.block"
                                            placeholder="# of Remote Sessions"
                                            :state="errors.length > 0 ? false:null"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                            readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="4">
                                <b-form-group
                                    label-for="# of Assessment Sessions"
                                >
                                <template v-slot:label>
                                    # of Assessment Sessions
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="# of Assessment Sessions"
                                        rules="required"
                                    >
                                        <cleave
                                            v-model="noAssessmentSessions"
                                            class="form-control"
                                            :raw="false"
                                            :options="options.block"
                                            placeholder="# of Assessment Sessions"
                                            :state="errors.length > 0 ? false:null"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                            readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                    label-for="# of Couple Sessions"
                                >
                                <template v-slot:label>
                                    # of Couple Sessions
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="# of Couple Sessions"
                                        rules="required"
                                    >
                                        <cleave
                                            v-model="noCoupleSessions"
                                            class="form-control"
                                            :raw="false"
                                            :options="options.block"
                                            placeholder="# of Couple Sessions"
                                            :state="errors.length > 0 ? false:null"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                            readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                    label-for="# of Family Sessions"
                                >
                                <template v-slot:label>
                                    # of Family Sessions
                                </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        name="# of Family Sessions"
                                        rules="required"
                                    >
                                        <cleave
                                            v-model="noFamilySessions"
                                            class="form-control"
                                            :raw="false"
                                            :options="options.block"
                                            placeholder="# of Family Sessions"
                                            :state="errors.length > 0 ? false:null"
                                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                                            readonly
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    
                </b-row>
                <!-- Form Actions -->
                <div class="d-flex mt-2 float-right">
                    <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="flat-primary"
                        @click="backList"
                    >
                    Back to list
                    </b-button>
                    <div v-if="!clinicianOrClinicianViewer">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="mr-2"
                            type="submit"
                            @click.prevent="validationForm"
                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                        >
                        Save
                        </b-button>
                    </div>
                    <div v-else>
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="mr-2"
                            type="submit"
                            @click.prevent="validationForm"
                            v-if="!isSelectedFromViewAllClaims && approvalStatus !== 'denied'"
                            :disabled="isSelectedFromViewAllClaims || dataSpecialist || ((approvalStatus === 'approved' || approvalStatus === 'paid') && !isAdmin) ? true : false"
                        >
                        Save
                        </b-button>
                    </div>
                </div>
            </b-form>
        </validation-observer>

        <!-- POP UP # of remote sesions -->
        <b-modal
            cancel-variant="outline-secondary"
            centered
            ref="modal-RemoteSessions"
            title="Remote Sessions"
            @ok="validationFormRemoteSesions"
            :hideHeaderClose="true"
            :no-close-on-backdrop="true"
            :close-on-backdrop="false"
            :close-on-esc="false"
            ok-only
        >
            <b-alert
                variant="danger"
                show
                v-if="msgRemoteSessions"
            >
                <div class="alert-body">
                    <span>{{ msgRemoteSessions }}</span>
                </div>
            </b-alert>
            <h6 class="mb-1"><span style="font-size: 14px; color: #000;">Total Remote Sessions </span>{{noRemoteSessions}}</h6>
            <validation-observer ref="editRemoteSesionsRules">
                <b-form>
                    <b-form-group
                        label-for="# of Remote Sessions"
                    >
                    <template v-slot:label>
                        # of Remote Sessions <span class="text-danger">*</span>
                    </template>
                        <validation-provider
                            #default="{ errors }"
                            name="# of Remote Sessions"
                            rules="required"
                        >
                            <cleave
                                v-model="noRemoteSessions"
                                class="form-control"
                                :raw="false"
                                :options="options.block"
                                placeholder="# of Remote Sessions"
                                :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group
                        label-for="# of Phone Sessions"
                    >
                    <template v-slot:label>
                        # of Phone Sessions <span class="text-danger">*</span>
                    </template>
                        <validation-provider
                            #default="{ errors }"
                            name="# of Phone Sessions"
                            rules="required"
                        >
                            <cleave
                                v-model="noPhoneSessions"
                                class="form-control"
                                :raw="false"
                                :options="options.block"
                                placeholder="# of Phone Sessions"
                                :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group
                        label-for="# of Video Sessions"
                    >
                    <template v-slot:label>
                        # of Video Sessions <span class="text-danger">*</span>
                    </template>
                        <validation-provider
                            #default="{ errors }"
                            name="# of Video Sessions"
                            rules="required"
                        >
                            <cleave
                                v-model="noVideoSessions"
                                class="form-control"
                                :raw="false"
                                :options="options.block"
                                placeholder="# of Video Sessions"
                                :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-form>
            </validation-observer>
        </b-modal>
    </div>
</template>

<script>
import { BForm, BButton, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BTable, BFormInvalidFeedback, BModal, VBModal, BAlert, } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { heightTransition } from '@core/mixins/ui/transition'
import flatPickr from 'vue-flatpickr-component'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { required, email } from '@validations'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapActions, mapState } from 'vuex'
import { db, auth } from '@/firebase'

export default {
    data() {
        return {
            // validation
            required,
            email,
            options: {
                block: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'false',
                    delimiter: ''
                },
            },
            userData: '',
            clinicianOrClinicianViewer: false,
            dataSpecialist: false,
            adminOrManageUsers: false,
            isAdmin: false,
            loadDataPage: false,
            msgRemoteSessions: '',
            isSelectedFromViewAllClaims: false,
            editClaimClinician: false,
            programClinician: '',

            // settings table and edit view
            statusEditClientClaim: true,
            itemsClaims: [],
            fieldsTable: [
                { key: 'clientID', sortable: false },
                { key: 'clientName', sortable: false },
                { key: 'approvalStatus', sortable: false },
                { key: 'claimDate', sortable: false },
            ],

            // form
            approvalStatus: 'pending pm approval',
            claimDateMonth: '',
            claimDateYear: '',
            client: '',
            dateOfBirthPGRCOASASProgram: null,
            sexAtBirth: '',
            last4SSN: '',
            firstTwoLettersLastName: '',
            noIndividualSessions: null,
            noGroupSessions: null,
            noRemoteSessions: null,
            noPhoneSessions: null,
            noVideoSessions: null,
            noAssessmentSessions: null,
            noCoupleSessions: null,
            noFamilySessions: null,
            clientInsurance: '',
            isInsuranceUtilizedForClaim: '',
            // isInsuranceUtilizedForClaim: YES
            insuranceReimbursementRateForIndividualSessions: null,
            insuranceReimbursementRateForGroupSessions: null,
            insuranceReimbursementRateForRemoteSessions: null,
            // isInsuranceUtilizedForClaim: No
            ifNotUtilizingInsurance: '',
            // isInsuranceUtilizedForClaim: Other
            ifNotUtilizingInsuranceResponseOther: '',
            clientProgressThisMonth: '',
            clientReportsSatisfactionWithTreatmentSessions: '',
            // clientReportsSatisfactionWithTreatmentSessions: No
            ifNoReportsSatisfaction: '',
            didClientProvideCopay: '',
            copayAmount: '',
            didClientUtilizeSlidingScale: '',
            amount: '',
            amountBilledToCFE: '$0.00',
            notes: '',

            // get data from db
            optionsClient: [],
            optionsClientApi: [],
            optionsClinician: [],
            noRemoteSessionsReal: null,

            optionssexAtBirth: [
                'Male',
                'Female'
            ],
            optionsDay: [
                '01', '02', '03', '04', '05',
                '06', '07', '08', '09', '10',
                '11', '12', '13', '14', '15',
                '16', '17', '18', '19', '20',
                '21', '22', '23', '24', '25',
                '26', '27', '28', '29', '30',
                '31',
            ],
            optionsMonths: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            optionsYears: [],
            optionsInsuranceType: [],
            optionsIsInsuranceUtilizedForClaim: ['Yes', 'No'],
            optionsIfNotUtilizingInsurance: [
                "Client doesn't have insurance",
                'Deductible not met',
                "Don't accept client's insurance",
                'Insurance does not cover telehealth services',
                'Other'
            ],
            optionsClientProgressThisMonth: ['N/A','Declined','Improved','No Change'],
            optionsClientReportsSatisfactionWithTreatmentSessions: ['Yes', 'No'],
            optionsDidClientProvideCopay: ['Yes', 'No'],
            optionsDidClientUtilizeSlidingScale: ['Yes', 'No'],

            // formRepeater Sessions
            itemsFormRepeater: [],
            nextTodoId: 1,
            optionsTypeOfSession: [
                'Assessment',
                'Individual',
                'Couple',
                'Family',
                'Group'
            ],
            optionsLengthOfSession: [
                '15 minutes',
                '30 minutes',
                '45 minutes',
                '60 minutes',
                '75 minutes',
                '90 minutes'
            ],
            optionsHowConducted: [
                'In-person',
                'Remote'
            ],
            optionsRemoteOption: ['Video','Phone'],
            optionsIsInsuranceUtilizedForSession: ['Yes','No'],
            optionsIsClientProvidingPaymentForSession: ['Yes','No'],
            ammountRegionCalculated1: 0,
            ammountRegionCalculated2: 0,
            individual15Min: 0,
            individual30Min: 0,
            individual45Min: 0,
            individual60Min: 0,
            individual75Min: 0,
            individual90Min: 0,
            group15Min: 0,
            group30Min: 0,
            group45Min: 0,
            group60Min: 0,
            group75Min: 0,
            group90Min: 0,

            // session observer
            typeSession: '',
            howConducted: '',
            remoteOption: '',
            amountCompany: '',
            amountCopay: '',
            amountSliding: '',
            subtotalPGRCobserver: 0,
            subtotalPGRC: 0,
            validFormRepeater: true,
        }
    },
    components: {
        BForm,
        BButton,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BTable,
        BFormInvalidFeedback,
        BModal,
        BAlert,
        Cleave,
        
        // select
        vSelect,

        // date
        flatPickr,
        DatePicker,

        // Form Validation
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        'b-modal': VBModal,
        Ripple,
    },
    mixins: [heightTransition],
    props: ['idClientClaim'],
    watch: {
        optionsClientApi(val) {
            // console.log(val,val.length)
            if(val.length >= 1) {
                val.forEach(client => {
                    // console.log(client.id)
                    db.collection('clients').doc(client.id).get()
                    .then(dataClinician => {
                        if(dataClinician.data().status === 'active') {
                            // console.log(dataClinician.data().id)
                            // var codigo = dataClinician.data().id ? ' (#' + dataClinician.data().id + ')' : ''
                            // var obj = dataClinician.data()
                            // obj.label = dataClinician.data().firstName + ' ' + dataClinician.data().lastName + codigo
                            // obj.id = dataClinician.id
                            // this.optionsClient.push(obj)

                            if(this.optionsClient.length >= 1) {
                                var findDuplicateClient = this.optionsClient.find(item => item.id === dataClinician.id);
                                if(!findDuplicateClient) {
                                    var codigo = dataClinician.data().id ? ' (#' + dataClinician.data().id + ')' : ''
                                    var obj = dataClinician.data()
                                    obj.label = dataClinician.data().firstName + ' ' + dataClinician.data().lastName + codigo
                                    obj.clientID = dataClinician.data().id
                                    obj.dateOfBirth = dataClinician.data().dateOfBirth ? dataClinician.data().dateOfBirth : ''
                                    obj.firstTwoLettersLastName = dataClinician.data().firstTwoLettersLastName ? dataClinician.data().firstTwoLettersLastName : ''
                                    obj.last4ofSSN = dataClinician.data().last4ofSSN ? dataClinician.data().last4ofSSN : ''
                                    obj.sexAtBirth = dataClinician.data().sexAtBirth ? dataClinician.data().sexAtBirth : ''
                                    obj.id = dataClinician.id
                                    this.optionsClient.push(obj)
                                }
                            } else {
                                var codigo = dataClinician.data().id ? ' (#' + dataClinician.data().id + ')' : ''
                                var obj = dataClinician.data()
                                obj.label = dataClinician.data().firstName + ' ' + dataClinician.data().lastName + codigo
                                obj.clientID = dataClinician.data().id
                                obj.dateOfBirth = dataClinician.data().dateOfBirth ? dataClinician.data().dateOfBirth : ''
                                obj.firstTwoLettersLastName = dataClinician.data().firstTwoLettersLastName ? dataClinician.data().firstTwoLettersLastName : ''
                                obj.last4ofSSN = dataClinician.data().last4ofSSN ? dataClinician.data().last4ofSSN : ''
                                obj.sexAtBirth = dataClinician.data().sexAtBirth ? dataClinician.data().sexAtBirth : ''
                                obj.id = dataClinician.id
                                this.optionsClient.push(obj)
                            }
                        }
                    })
                })
                // console.log(this.optionsClient)
            }
        },
        typeSession(val) {
            this.counterSession()
        },
        howConducted(val) {
            this.counterSession()
        },
        remoteOption(val) {
            this.counterSession()
        },
        amountCompany(val) {
            this.counterSession()
        },
        amountCopay(val) {
            this.counterSession()
        },
        amountSliding(val) {
            this.counterSession()
        },
        subtotalPGRCobserver(val) {
            this.amountSession()
        },
        idClientClaim(val) {
            // console.log(val)
            this.statusEditClientClaim = true
            db.collection('clientsClaims').doc(val).get()
            .then(dataClientClaim => {
                db.collection('clients').get()
                .then(itemClient => {
                    // get client
                    var objClient = ''
                    if(dataClientClaim.data().client) {
                        itemClient.forEach(item => {
                            if(dataClientClaim.data().client === item.id) {
                                var codigo = item.data().id ? ' (#' + item.data().id + ')' : ''
                                objClient = item.data()
                                objClient.label = item.data().firstName + ' ' + item.data().lastName + codigo
                                objClient.id = item.id
                            }
                        })
                    }

                    this.approvalStatus = dataClientClaim.data().approvalStatus
                    this.claimDateMonth = dataClientClaim.data().claimDateMonth
                    this.claimDateYear = dataClientClaim.data().claimDateYear
                    this.noIndividualSessions = dataClientClaim.data().noIndividualSessions
                    this.noGroupSessions = dataClientClaim.data().noGroupSessions
                    this.noRemoteSessions = dataClientClaim.data().noRemoteSessions
                    this.noPhoneSessions = dataClientClaim.data().noPhoneSessions ? dataClientClaim.data().noPhoneSessions : ''
                    this.noVideoSessions = dataClientClaim.data().noVideoSessions ? dataClientClaim.data().noVideoSessions : ''
                    this.noAssessmentSessions = dataClientClaim.data().noAssessmentSessions ? dataClientClaim.data().noAssessmentSessions : ''
                    this.noCoupleSessions = dataClientClaim.data().noCoupleSessions ? dataClientClaim.data().noCoupleSessions : ''
                    this.noFamilySessions = dataClientClaim.data().noFamilySessions ? dataClientClaim.data().noFamilySessions : ''
                    this.clientInsurance = dataClientClaim.data().clientInsurance
                    this.isInsuranceUtilizedForClaim = dataClientClaim.data().isInsuranceUtilizedForClaim
                    // isInsuranceUtilizedForClaim = dataClientClaim.data().
                    this.insuranceReimbursementRateForIndividualSessions = dataClientClaim.data().insuranceReimbursementRateForIndividualSessions
                    this.insuranceReimbursementRateForGroupSessions = dataClientClaim.data().insuranceReimbursementRateForGroupSessions
                    this.insuranceReimbursementRateForRemoteSessions = dataClientClaim.data().insuranceReimbursementRateForRemoteSessions
                    // isInsuranceUtilizedForClaim = dataClientClaim.data().
                    this.ifNotUtilizingInsurance = dataClientClaim.data().ifNotUtilizingInsurance
                    // ifNotUtilizingInsurance: Other
                    this.ifNotUtilizingInsuranceResponseOther = dataClientClaim.data().ifNotUtilizingInsuranceResponseOther ? dataClientClaim.data().ifNotUtilizingInsuranceResponseOther : ''
                    this.clientProgressThisMonth = dataClientClaim.data().clientProgressThisMonth
                    this.clientReportsSatisfactionWithTreatmentSessions = dataClientClaim.data().clientReportsSatisfactionWithTreatmentSessions
                    // clientReportsSatisfactionWithTreatmentSessions = dataClientClaim.data().
                    this.ifNoReportsSatisfaction = dataClientClaim.data().ifNoReportsSatisfaction
                    this.didClientProvideCopay = dataClientClaim.data().didClientProvideCopay ? dataClientClaim.data().didClientProvideCopay : ''
                    this.copayAmount = dataClientClaim.data().copayAmount ? dataClientClaim.data().copayAmount : ''
                    this.didClientUtilizeSlidingScale = dataClientClaim.data().didClientUtilizeSlidingScale ? dataClientClaim.data().didClientUtilizeSlidingScale : ''
                    this.amount = dataClientClaim.data().amount ? dataClientClaim.data().amount : ''
                    this.amountBilledToCFE = dataClientClaim.data().amountBilledToCFE
                    this.notes = dataClientClaim.data().notes
                    this.client = objClient
                    this.dateOfBirthPGRCOASASProgram = dataClientClaim.data().dateOfBirthPGRCOASASProgram ? dataClientClaim.data().dateOfBirthPGRCOASASProgram : ''
                    this.sexAtBirth = dataClientClaim.data().sexAtBirth ? dataClientClaim.data().sexAtBirth : ''
                    this.last4SSN = dataClientClaim.data().last4SSN ? dataClientClaim.data().last4SSN : ''
                    this.firstTwoLettersLastName = dataClientClaim.data().firstTwoLettersLastName ? dataClientClaim.data().firstTwoLettersLastName : ''
                    this.itemsFormRepeater = dataClientClaim.data().itemsFormRepeater ? dataClientClaim.data().itemsFormRepeater : []
                    this.counterSession()
                })
            })
        },
        noRemoteSessions(val) {
            var noRemoteSessionsAtomic =  parseInt(val, 10)
            var noRemoteSessionsAtomicReal =  parseInt(this.noRemoteSessionsReal, 10)
            if(noRemoteSessionsAtomic >= 1) {
                if(noRemoteSessionsAtomic !== noRemoteSessionsAtomicReal) {
                    // setTimeout(() => {
                    //     this.$refs['modal-RemoteSessions'].show()
                    //     // console.log(noRemoteSessionsAtomic)
                    // }, 1000)
                }
            } else if(noRemoteSessionsAtomic === 0) {
                this.noPhoneSessions = 0
                this.noVideoSessions = 0
            }
            this.calculateAmountBilledToCFE()
        },
        isInsuranceUtilizedForClaim(val) {
            if(val === 'Yes') {
                this.calculateAmountBilledToCFE()
            } else {
                this.insuranceReimbursementRateForIndividualSessions = 0
                this.insuranceReimbursementRateForGroupSessions = 0
                this.insuranceReimbursementRateForRemoteSessions = 0
            }
        },
        insuranceReimbursementRateForIndividualSessions() {
            this.calculateAmountBilledToCFE()
        },
        insuranceReimbursementRateForGroupSessions() {
            this.calculateAmountBilledToCFE()
        },
        insuranceReimbursementRateForRemoteSessions() {
            this.calculateAmountBilledToCFE()
        },
        noIndividualSessions() {
            this.calculateAmountBilledToCFE()
        },
        noGroupSessions() {
            this.calculateAmountBilledToCFE()
        },
        client(val) {
            // console.log(val,val?.dateOfBirth ? val?.dateOfBirth : '')
            if(val) {
                this.dateOfBirthPGRCOASASProgram = val?.dateOfBirth ? val?.dateOfBirth : ''
                this.sexAtBirth = val?.sexAtBirth ? val?.sexAtBirth : ''
                this.last4SSN = val?.last4ofSSN ? val?.last4ofSSN : ''
                this.firstTwoLettersLastName = val?.firstTwoLettersLastName ? val?.firstTwoLettersLastName : ''
            }
        }
    },
    computed: {
        ...mapState(['usuario'])
    },
    methods: {
        ...mapActions(['updateClientClaim']),
        changeClaimDateMonth(val) {
            // console.log('id: ',val)
            // console.log(this.$refs.myInput.value,document.getElementsByClassName('vs__search'))
            document.getElementsByClassName('vs__search').forEach(ele => {
                // console.log(ele.autocomplete, ele.value)
                if(ele.autocomplete === 'on' || ele.placeholder === 'Day of Session') {
                    // console.log(ele)
                    // console.log('keypress 1: ',ele.value)
                    var filterRepeter = this.itemsFormRepeater.filter(item => item.id === val)
                    if(filterRepeter.length >= 1) {
                        filterRepeter.forEach(eleItem => {
                            if(ele.value === '1' || ele.value === '01') {
                                eleItem.dayOfSession = '01'
                            } else if(ele.value === '2' || ele.value === '02') {
                                eleItem.dayOfSession = '02'
                            } else if(ele.value === '3' || ele.value === '03') {
                                eleItem.dayOfSession = '03'
                            } else if(ele.value === '4' || ele.value === '04') {
                                eleItem.dayOfSession = '04'
                            } else if(ele.value === '5' || ele.value === '05') {
                                eleItem.dayOfSession = '05'
                            } else if(ele.value === '6' || ele.value === '06') {
                                eleItem.dayOfSession = '06'
                            } else if(ele.value === '7' || ele.value === '07') {
                                eleItem.dayOfSession = '07'
                            } else if(ele.value === '8' || ele.value === '08') {
                                eleItem.dayOfSession = '08'
                            } else if(ele.value === '9' || ele.value === '09') {
                                eleItem.dayOfSession = '09'
                            } else {
                                var validDayValue = parseInt(ele.value, 10)
                                if(validDayValue && validDayValue <= 31) {
                                    eleItem.dayOfSession = validDayValue.toString()
                                }
                            }
                        })
                        // console.log('keypress 2: ',ele.value)
                    }
                }
            })
        },
        amountSession() {
            this.subtotalPGRC = 0

            if(this.itemsFormRepeater.length >= 1) {
                this.itemsFormRepeater.forEach(item => {
                    // console.log(item.subtotalBilledToPGRC.replace(/[$]/g, ''))
                    if(item.subtotalBilledToPGRC) {
                        var atomSubtotal = item.subtotalBilledToPGRC.replace(/[$]/g, '')
                        this.subtotalPGRC += parseFloat(atomSubtotal)
                        // console.log(this.subtotalPGRC)
                    }
                })
                this.counterSession()
            }
        },
        counterSession() {
            this.noIndividualSessions = 0
            this.noGroupSessions = 0
            this.noRemoteSessions = 0
            this.noAssessmentSessions = 0
            this.noCoupleSessions = 0
            this.noFamilySessions = 0
            this.noPhoneSessions = 0
            this.noVideoSessions = 0
            // console.log(val)

            // typeOfSession
            if(this.itemsFormRepeater.length >= 1) {
                this.itemsFormRepeater.forEach(item => {
                    if(item.typeOfSession === 'Assessment') {
                        this.noAssessmentSessions += 1
                    } else if(item.typeOfSession === 'Individual') {
                        if(item.howConducted === 'Remote') {
                            this.noRemoteSessions += 1

                            if(item.remoteOption === 'Phone') {
                                this.noPhoneSessions += 1
                            } else if(item.remoteOption === 'Video') {
                                this.noVideoSessions += 1
                            }
                        } else if(item.howConducted === 'In-person') {
                            this.noIndividualSessions += 1
                        } else {
                            this.noIndividualSessions += 1
                        }
                    } else if(item.typeOfSession === 'Couple') {
                        this.noCoupleSessions += 1
                    } else if(item.typeOfSession === 'Family') {
                        this.noFamilySessions += 1
                    } else if(item.typeOfSession === 'Group') {
                        this.noGroupSessions += 1
                    } else if(item.typeOfSession === 'Remote') {
                        this.noRemoteSessions += 1
                    }

                    item.amount ? item.amount = parseFloat(item.amount) : item.amount= 0
                    item.copayAmount ? item.copayAmount = parseFloat(item.copayAmount) : item.copayAmount = 0
                    // item.enterAmmountInsuranceCompanyPay ? item.enterAmmountInsuranceCompanyPay = parseFloat(item.enterAmmountInsuranceCompanyPay) : item.enterAmmountInsuranceCompanyPay = 0
                    // console.log(item.amount,item.copayAmount,item.enterAmmountInsuranceCompanyPay,this.subtotalPGRCobserver)

                    // if(item.subtotalBilledToPGRC) {
                    //     var atomSubtotal = item.subtotalBilledToPGRC.replace(/[$]/g, '')
                    //     this.subtotalPGRC += parseFloat(atomSubtotal)
                    // }
                })
            }
        },
        calculateAmountBilledToCFE() {
            // var RegionRate = 0.00
            // var GroupRegionRate = 0.00
            // var RemoteRegionRate = 0.00
            // if(this.userData.region.toLowerCase() === 'western') {
            //     RegionRate = 80.00
            //     GroupRegionRate = 80.00
            //     RemoteRegionRate = 80.00
            // } else if(this.userData.region.toLowerCase() === 'finger lakes') {
            //     RegionRate = 80.00
            //     GroupRegionRate = 80.00
            //     RemoteRegionRate = 80.00
            // } else if(this.userData.region.toLowerCase() === 'central') {
            //     RegionRate = 80.00
            //     GroupRegionRate = 80.00
            //     RemoteRegionRate = 80.00
            // } else if(this.userData.region.toLowerCase() === 'northeast') {
            //     RegionRate = 80.00
            //     GroupRegionRate = 80.00
            //     RemoteRegionRate = 80.00
            // } else if(this.userData.region.toLowerCase() === 'mid-hudson') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'bronx') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'brooklyn') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'manhattan') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'queens') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'staten island') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // } else if(this.userData.region.toLowerCase() === 'long island') {
            //     RegionRate = 90.00
            //     GroupRegionRate = 90.00
            //     RemoteRegionRate = 90.00
            // }

            // var regionRate = this.userData.region ? RegionRate : RegionRate;
            // var groupRegionRate = this.userData.region ? GroupRegionRate : GroupRegionRate;
            // var remoteRegionRate = this.userData.region ? RemoteRegionRate : RemoteRegionRate;

            // if(!this.noIndividualSessions) this.noIndividualSessions = 0
            // if(!this.insuranceReimbursementRateForIndividualSessions) this.insuranceReimbursementRateForIndividualSessions = 0
            // if(!this.noRemoteSessions) this.noRemoteSessions = 0
            // if(!this.insuranceReimbursementRateForRemoteSessions) this.insuranceReimbursementRateForRemoteSessions = 0
            // if(!this.noGroupSessions) this.noGroupSessions = 0
            // if(!this.insuranceReimbursementRateForGroupSessions) this.insuranceReimbursementRateForGroupSessions = 0
            
            // var individualSessionsCost = parseFloat(this.noIndividualSessions) > 0 ? parseFloat(this.noIndividualSessions)*(regionRate - parseFloat(this.insuranceReimbursementRateForIndividualSessions)) : 0;
            // var remoteSessionsCost = parseFloat(this.noRemoteSessions) > 0 ? parseFloat(this.noRemoteSessions) * (remoteRegionRate - parseFloat(this.insuranceReimbursementRateForRemoteSessions)) : 0;
            // var groupSessionsCost = parseFloat(this.noGroupSessions) > 0 ? parseFloat(this.noGroupSessions) * ((groupRegionRate / 2) - parseFloat(this.insuranceReimbursementRateForGroupSessions)) : 0;

            // var resultAmountBilledToCFE = individualSessionsCost + remoteSessionsCost + groupSessionsCost;
            // var resultAmountBilledToCFESum = parseInt(resultAmountBilledToCFE, 10) + parseInt(this.subtotalPGRC, 10)
            // console.log(individualSessionsCost,remoteSessionsCost,groupSessionsCost,resultAmountBilledToCFE);
            var resultAmountBilledToCFESum = 0
            if(this.itemsFormRepeater.length >= 1) {
                this.itemsFormRepeater.forEach(item => {
                    resultAmountBilledToCFESum += item.subtotalBilledToPGRC.includes('$') ? parseFloat(item.subtotalBilledToPGRC.substring(1)) : parseFloast(item.subtotalBilledToPGRC)
                })
            }
            this.amountBilledToCFE = '$' + resultAmountBilledToCFESum
        },
        submitFormClientClaim() {
            var claimDateFormat = '01/'+moment().month(this.claimDateMonth).format("MM")+ '/' + this.claimDateYear
            var dateCheck = claimDateFormat.split("/")
            var check = new Date(dateCheck[2], parseInt(dateCheck[1])-1, dateCheck[0])
            
            var idOASASProgram = ''
            if(this.programClinician === 'PGRC - OASAS Program') {
                if(this.dateOfBirthPGRCOASASProgram && this.firstTwoLettersLastName) {
                    var idClaimOASAS = this.dateOfBirthPGRCOASASProgram.replace(/-/g, '') + this.firstTwoLettersLastName
                    idOASASProgram = idClaimOASAS
                }
            }
            
            var objClient = {
                idOASASProgram: idOASASProgram ? idOASASProgram : '',

                // data update filter
                clientID: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.clientID,
                clientName: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.firstName + ' ' + this.client.lastName,
                clientStatus: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.status,
                languageClient: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.primaryLanguage,
                regionClient: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.countryOfResidence,
                clinicianID: this.userData.codigo,
                clinicianName: this.userData.firstName + ' ' + this.userData.lastName,
                region: this.userData.region,
                regionBorough: this.userData.borough ? this.userData.borough : '',
                statusClinician: this.userData.statusReferral ? this.userData.statusReferral : '',
                clinicianProgram: this.userData.program ? this.userData.program : '',

                // form
                // clinician: this.$route.params.id,
                // approvalStatus: this.approvalStatus,
                claimDateMonth: this.claimDateMonth,
                claimDateYear: this.claimDateYear,
                noIndividualSessions: this.noIndividualSessions,
                noGroupSessions: this.noGroupSessions,
                noRemoteSessions: this.noRemoteSessions,
                noPhoneSessions: this.noPhoneSessions,
                noVideoSessions: this.noVideoSessions,
                noAssessmentSessions: this.noAssessmentSessions,
                noCoupleSessions: this.noCoupleSessions,
                noFamilySessions: this.noFamilySessions,
                clientInsurance: this.clientInsurance,
                isInsuranceUtilizedForClaim: this.isInsuranceUtilizedForClaim,
                // isInsuranceUtilizedForClaim: YES
                insuranceReimbursementRateForIndividualSessions: this.insuranceReimbursementRateForIndividualSessions,
                insuranceReimbursementRateForGroupSessions: this.insuranceReimbursementRateForGroupSessions,
                insuranceReimbursementRateForRemoteSessions: this.insuranceReimbursementRateForRemoteSessions,
                // isInsuranceUtilizedForClaim: No
                ifNotUtilizingInsurance: this.ifNotUtilizingInsurance,
                // ifNotUtilizingInsurance: Other
                ifNotUtilizingInsuranceResponseOther: this.ifNotUtilizingInsuranceResponseOther,
                clientProgressThisMonth: this.clientProgressThisMonth,
                clientReportsSatisfactionWithTreatmentSessions: this.clientReportsSatisfactionWithTreatmentSessions,
                // clientReportsSatisfactionWithTreatmentSessions: No
                ifNoReportsSatisfaction: this.ifNoReportsSatisfaction,
                didClientProvideCopay: this.didClientProvideCopay,
                copayAmount: this.copayAmount,
                didClientUtilizeSlidingScale: this.didClientUtilizeSlidingScale,
                amount: this.amount,
                amountBilledToCFE: this.amountBilledToCFE,
                notes: this.notes,
                client: this.programClinician === 'PGRC - OASAS Program' ? '' : this.client.id,
                dateOfBirthPGRCOASASProgram: this.dateOfBirthPGRCOASASProgram,
                sexAtBirth: this.sexAtBirth,
                last4SSN: this.last4SSN,
                firstTwoLettersLastName: this.firstTwoLettersLastName,
                itemsFormRepeater: this.itemsFormRepeater,
                // created: Date.now()
                status: 'active',

                claimDate: this.claimDateYear + '/' + moment().month(this.claimDateMonth).format("MM") + '/01 00:00:00',
                claimStamp: check,
                claimTime: this.claimDateYear + '-' + moment().month(this.claimDateMonth).format("MM") + '-01 00:00:00',
            }
            // snapshot clinician
            db.collection('clientsClaims').doc(this.idClientClaim).get()
            .then(dataClientClaim => {
                if(dataClientClaim.data().clinician) {
                    db.collection('usuarios').doc(dataClientClaim.data().clinician).update({
                        updated: Date.now()
                    })
                }
            })

            this.updateClientClaim({id: this.idClientClaim, data: objClient})
            this.statusEditClientClaim = false
            this.$emit('statusEditClientClaim',false)
            // reset form
            this.approvalStatus = 'pending pm approval'
            this.claimDateMonth = ''
            this.claimDateYear = ''
            this.noIndividualSessions = null
            this.noGroupSessions = null
            this.noRemoteSessions = null
            this.noPhoneSessions = null
            this.noVideoSessions = null
            this.noAssessmentSessions = null
            this.noCoupleSessions = null
            this.noFamilySessions = null
            this.clientInsurance = ''
            this.isInsuranceUtilizedForClaim = ''
            // isInsuranceUtilizedForClaim: YES
            this.insuranceReimbursementRateForIndividualSessions = null
            this.insuranceReimbursementRateForGroupSessions = null
            this.insuranceReimbursementRateForRemoteSessions = null
            // isInsuranceUtilizedForClaim: No
            this.ifNotUtilizingInsurance = ''
            // ifNotUtilizingInsurance: Other
            this.ifNotUtilizingInsuranceResponseOther = ''
            this.clientProgressThisMonth = ''
            this.clientReportsSatisfactionWithTreatmentSessions = ''
            // clientReportsSatisfactionWithTreatmentSessions: No
            this.ifNoReportsSatisfaction = ''
            this.didClientProvideCopay = ''
            this.copayAmount = ''
            this.didClientUtilizeSlidingScale = ''
            this.amount = ''
            this.amountBilledToCFE = '$0.00'
            this.notes = ''
            this.client = ''
            this.dateOfBirthPGRCOASASProgram = ''
            this.sexAtBirth = ''
            this.last4SSN = ''
            this.firstTwoLettersLastName = ''
            this.itemsFormRepeater = []
        },
        validationForm() {
            this.$refs.editClinicianRules.validate().then(success => {
                if(success) {
                    // check validation form repeater
                    this.validFormRepeater = true
                    var validateFormRepeater = true
                    this.itemsFormRepeater.forEach(ele => {
                        // ele.valid = true
                        // id: this.nextTodoId += this.itemsFormRepeater.length,
                        // dayOfSession: '',1
                        // typeOfSession: '',2
                        // lengthOfSession: '',3
                        // howConducted: '',4
                        // remoteOption: '',5
                        // isInsuranceUtilizedForSession: '',6
                        // nameOfInsuranceCompany: '',7
                        // enterAmmountInsuranceCompanyPay: null,8
                        // ifNotUtilizingInsuranceSession: '',14
                        // ifNotUtilizingInsuranceSessionResponseOther: '',15
                        // didClientProvideCopay: '',9
                        // copayAmount: '',10
                        // didClientUtilizeSlidingScale: '',11
                        // amount: '',12

                        if(!ele.dayOfSession || !ele.typeOfSession || !ele.lengthOfSession || !ele.howConducted || !ele.isInsuranceUtilizedForSession || !ele.didClientUtilizeSlidingScale) {
                            validateFormRepeater = false
                        }

                        if(ele.howConducted === 'Remote' && !ele.remoteOption) {
                            validateFormRepeater = false
                        }

                        // if(ele.isInsuranceUtilizedForSession === 'Yes') {
                        //     if(!ele.didClientProvideCopay) {
                        //         validateFormRepeater = false
                        //     }
                        // }

                        if(ele.isInsuranceUtilizedForSession === 'Yes' && (!ele.nameOfInsuranceCompany || ele.enterAmmountInsuranceCompanyPay === '')) {
                            // validateFormRepeater = false
                        } else if(ele.isInsuranceUtilizedForSession === 'No') {
                            // if(!ele.ifNotUtilizingInsuranceSession) {
                            //     validateFormRepeater = false
                            // } else if(ele.ifNotUtilizingInsuranceSession === 'Other') {
                            //     if(!ele.ifNotUtilizingInsuranceSessionResponseOther) {
                            //         validateFormRepeater = false
                            //     }
                            // }
                        }

                        // if(ele.didClientProvideCopay === 'Yes') {
                        //     if(ele.copayAmount === '') {
                        //         validateFormRepeater = false
                        //     }
                        // }

                        if(ele.didClientUtilizeSlidingScale === 'Yes') {
                            if(ele.amount === '') {
                                validateFormRepeater = false
                            }
                        }

                        // subtotalBilledToPGRC: '$0.00', 13
                        // isClientProvidingPaymentForSession: '',
                        // enterAmountClientPaysForSession: '',
                    })
                    // console.log(validateFormRepeater)
                    
                    // eslint-disable-next-line
                    if(validateFormRepeater) {
                        this.submitFormClientClaim()
                        // console.log('submit')
                    } else {
                        this.validFormRepeater = false
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `(*) One or more required field(s) are missing.`,
                                icon: 'CoffeeIcon',
                                variant: 'danger',
                            },
                        })
                    }
                } else {
                    this.validFormRepeater = true
                    var validateFormRepeater = true
                    this.itemsFormRepeater.forEach(ele => {
                        if(!ele.dayOfSession || !ele.typeOfSession || !ele.lengthOfSession || !ele.howConducted || !ele.isInsuranceUtilizedForSession || !ele.didClientUtilizeSlidingScale) {
                            validateFormRepeater = false
                        }

                        if(ele.howConducted === 'Remote' && !ele.remoteOption) {
                            validateFormRepeater = false
                        }

                        // if(ele.isInsuranceUtilizedForSession === 'Yes') {
                        //     if(!ele.didClientProvideCopay) {
                        //         validateFormRepeater = false
                        //     }
                        // }
                        
                        if(ele.isInsuranceUtilizedForSession === 'Yes' && (!ele.nameOfInsuranceCompany || ele.enterAmmountInsuranceCompanyPay === '')) {
                            // validateFormRepeater = false
                        } else if(ele.isInsuranceUtilizedForSession === 'No') {
                            // if(!ele.ifNotUtilizingInsuranceSession) {
                            //     validateFormRepeater = false
                            // } else if(ele.ifNotUtilizingInsuranceSession === 'Other') {
                            //     if(!ele.ifNotUtilizingInsuranceSessionResponseOther) {
                            //         validateFormRepeater = false
                            //     }
                            // }
                        }

                        // if(ele.didClientProvideCopay === 'Yes') {
                        //     if(ele.copayAmount === '') {
                        //         validateFormRepeater = false
                        //     }
                        // }

                        if(ele.didClientUtilizeSlidingScale === 'Yes') {
                            if(ele.amount === '') {
                                validateFormRepeater = false
                            }
                        }
                    })
                    
                    if(!validateFormRepeater) {
                        this.validFormRepeater = false
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `(*) One or more required field(s) are missing.`,
                                icon: 'CoffeeIcon',
                                variant: 'danger',
                            },
                        })
                    }
                }
            })
        },
        validationFormRemoteSesions(bvModalEvt) {
            bvModalEvt.preventDefault()
            this.$refs.editRemoteSesionsRules.validate().then(success => {
                if (success) {
                    // this.submitFormClientClaim()
                    // noRemoteSessions: null,
                    // noPhoneSessions: null,
                    // noVideoSessions: null,
                    var noRemoteSessionsAtomic =  parseInt(this.noRemoteSessions, 10)
                    var noPhoneSessionsAtomic =  parseInt(this.noPhoneSessions, 10)
                    var noVideoSessionsAtomic =  parseInt(this.noVideoSessions, 10)

                    var sumRemoteSessions = noPhoneSessionsAtomic + noVideoSessionsAtomic
                    
                    if (noRemoteSessionsAtomic === sumRemoteSessions) {
                        this.msgRemoteSessions = ''
                        this.$refs['modal-RemoteSessions'].hide()
                    } else if(noRemoteSessionsAtomic < sumRemoteSessions) {
                        this.msgRemoteSessions = '# of Remote sessions cannot be less than the sum of # of Phone Sessions and # of Video Sessions'
                    } else if(noRemoteSessionsAtomic > sumRemoteSessions) {
                        this.msgRemoteSessions = 'Remote sessions cannot be higher than the sum of # of Phone Sessions and # of Video Sessions'
                    }
                }
            })
        },
        backList() {
            this.statusEditClientClaim = false
            this.$emit('statusEditClientClaim',false)
        },
        // repeaterForm sessions
        repeateAgain() {
            this.itemsFormRepeater.push({
                id: this.nextTodoId += this.itemsFormRepeater.length,
                dayOfSession: '',
                typeOfSession: '',
                lengthOfSession: '',
                howConducted: '',
                remoteOption: '',
                isInsuranceUtilizedForSession: '',
                nameOfInsuranceCompany: '',
                enterAmmountInsuranceCompanyPay: null,
                // isInsuranceUtilizedForSession: '',
                ifNotUtilizingInsuranceSession: '',
                ifNotUtilizingInsuranceSessionResponseOther: '',
                isClientProvidingPaymentForSession: '',
                enterAmountClientPaysForSession: '',
                didClientProvideCopay: '',
                copayAmount: '',
                didClientUtilizeSlidingScale: '',
                amount: '',
                subtotalBilledToPGRC: '$0.00',
            })

            this.$nextTick(() => {
                this.trAddHeight(this.$refs.row[0].offsetHeight)
            })
        },
        removeItem(index) {
            this.itemsFormRepeater.splice(index, 1)
            this.counterSession()
            this.trTrimHeight(this.$refs.row[0].offsetHeight)
        },
        initTrHeight() {
            this.trSetHeight(null)
            this.$nextTick(() => {
                this.trSetHeight(this.$refs.formRepeaterSessions.scrollHeight)
            })
        },
    },
    created() {
        this.programClinician = ''
        window.addEventListener('resize', this.initTrHeight)

        const user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(userDoc => {
            if(userDoc.data().role === 'admin') {
                this.adminOrManageUsers = true
                this.isAdmin = true
            } else if(userDoc.data().role === 'staff') {
                if(userDoc.data().permissions.includes('manage users') || userDoc.data().permissions.includes('program manager - vse')) {
                    this.adminOrManageUsers = true
                } else if(userDoc.data().permissions.includes('data specialist')) {
                    this.dataSpecialist = true
                } else if(userDoc.data().permissions.includes('clinician viewer')) {
                    this.clinicianOrClinicianViewer = true
                } else {
                    this.clinicianOrClinicianViewer = true
                }
            } else if(userDoc.data().role === 'clinician' || userDoc.data().role === 'clinician-staff') {
                this.clinicianOrClinicianViewer = true
            }

            if(userDoc.data().role === 'clinician-staff') {
                if(this.$route.params.id) {
                    var idOwnerClinician = userDoc.data().dependency
                    db.collection('usuarios').doc(idOwnerClinician).get()
                    .then(userDoc => {
                        this.programClinician = userDoc.data().program ? userDoc.data().program : ''
                        this.userData = userDoc.data()

                        if(userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                            this.ammountRegionCalculated1 = 90
                        } else {
                            this.ammountRegionCalculated1 = 45
                        }

                        if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                            this.ammountRegionCalculated2 = 80
                        } else {
                            this.ammountRegionCalculated2 = 40
                        }

                        if(userDoc.data().region.toLowerCase() === 'mid-hudson' || userDoc.data().region.toLowerCase() === 'long island' || userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                            // this.individual45Min = 140
                            // this.individual90Min = 280
                            // this.group45Min = 70
                            // this.group90Min = 140
                            this.individual15Min = 47
                            this.individual30Min = 94
                            this.individual45Min = 140
                            this.individual60Min = 187
                            this.individual75Min = 234
                            this.individual90Min = 280
                            this.group15Min = 23.5
                            this.group30Min = 47
                            this.group45Min = 70
                            this.group60Min = 93.5
                            this.group75Min = 117
                            this.group90Min = 140
                        }
                        if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                            // this.individual45Min = 120
                            // this.individual90Min = 240
                            // this.group45Min = 60
                            // this.group90Min = 120
                            this.individual15Min = 40
                            this.individual30Min = 80
                            this.individual45Min = 120
                            this.individual60Min = 160
                            this.individual75Min = 200
                            this.individual90Min = 240
                            this.group15Min = 20
                            this.group30Min = 40
                            this.group45Min = 60
                            this.group60Min = 80
                            this.group75Min = 100
                            this.group90Min = 120
                        }
                    })
                } else {
                    this.isSelectedFromViewAllClaims = true
                    
                    db.collection('clientsClaims').doc(this.idClientClaim).get()
                    .then(dataClientClaim => {
                        db.collection('usuarios').doc(dataClientClaim.data().clinician).get()
                        .then(userDoc => {
                            this.userData = userDoc.data()
                            this.programClinician = userDoc.data().program ? userDoc.data().program : ''
                        })
                    })
                }
            } else {
                if(this.$route.params.id) {
                    db.collection('usuarios').doc(this.$route.params.id).get()
                    .then(userDoc => {
                        if(userDoc.data().role === 'clinician-staff') {
                            var idOwnerClinician = userDoc.data().dependency
                            db.collection('usuarios').doc(idOwnerClinician).get()
                            .then(userDocDep => {
                                this.programClinician = userDoc.data().program ? userDoc.data().program : ''
                                this.userData = userDoc.data()

                                if(userDocDep.data().region.toLowerCase() === 'nyc' || userDocDep.data().region.toLowerCase() === 'bronx' || userDocDep.data().region.toLowerCase() === 'brooklyn' || userDocDep.data().region.toLowerCase() === 'manhattan' || userDocDep.data().region.toLowerCase() === 'queens' || userDocDep.data().region.toLowerCase() === 'staten island') {
                                    this.ammountRegionCalculated1 = 90
                                } else {
                                    this.ammountRegionCalculated1 = 45
                                }

                                if(userDocDep.data().region.toLowerCase() === 'northeast' || userDocDep.data().region.toLowerCase() === 'central' || userDocDep.data().region.toLowerCase() === 'finger lakes' || userDocDep.data().region.toLowerCase() === 'western') {
                                    this.ammountRegionCalculated2 = 80
                                } else {
                                    this.ammountRegionCalculated2 = 40
                                }

                                if(userDocDep.data().region.toLowerCase() === 'mid-hudson' || userDocDep.data().region.toLowerCase() === 'long island' || userDocDep.data().region.toLowerCase() === 'nyc' || userDocDep.data().region.toLowerCase() === 'bronx' || userDocDep.data().region.toLowerCase() === 'brooklyn' || userDocDep.data().region.toLowerCase() === 'manhattan' || userDocDep.data().region.toLowerCase() === 'queens' || userDocDep.data().region.toLowerCase() === 'staten island') {
                                    // this.individual45Min = 140
                                    // this.individual90Min = 280
                                    // this.group45Min = 70
                                    // this.group90Min = 140
                                    this.individual15Min = 47
                                    this.individual30Min = 94
                                    this.individual45Min = 140
                                    this.individual60Min = 187
                                    this.individual75Min = 234
                                    this.individual90Min = 280
                                    this.group15Min = 23.5
                                    this.group30Min = 47
                                    this.group45Min = 70
                                    this.group60Min = 93.5
                                    this.group75Min = 117
                                    this.group90Min = 140
                                }
                                if(userDocDep.data().region.toLowerCase() === 'northeast' || userDocDep.data().region.toLowerCase() === 'central' || userDocDep.data().region.toLowerCase() === 'finger lakes' || userDocDep.data().region.toLowerCase() === 'western') {
                                    // this.individual45Min = 120
                                    // this.individual90Min = 240
                                    // this.group45Min = 60
                                    // this.group90Min = 120
                                    this.individual15Min = 40
                                    this.individual30Min = 80
                                    this.individual45Min = 120
                                    this.individual60Min = 160
                                    this.individual75Min = 200
                                    this.individual90Min = 240
                                    this.group15Min = 20
                                    this.group30Min = 40
                                    this.group45Min = 60
                                    this.group60Min = 80
                                    this.group75Min = 100
                                    this.group90Min = 120
                                }
                            })
                        } else {
                            this.programClinician = userDoc.data().program ? userDoc.data().program : ''
                            this.userData = userDoc.data()

                            if(userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                                this.ammountRegionCalculated1 = 90
                            } else {
                                this.ammountRegionCalculated1 = 45
                            }

                            if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                                this.ammountRegionCalculated2 = 80
                            } else {
                                this.ammountRegionCalculated2 = 40
                            }

                            if(userDoc.data().region.toLowerCase() === 'mid-hudson' || userDoc.data().region.toLowerCase() === 'long island' || userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                                // this.individual45Min = 140
                                // this.individual90Min = 280
                                // this.group45Min = 70
                                // this.group90Min = 140
                                this.individual15Min = 47
                                this.individual30Min = 94
                                this.individual45Min = 140
                                this.individual60Min = 187
                                this.individual75Min = 234
                                this.individual90Min = 280
                                this.group15Min = 23.5
                                this.group30Min = 47
                                this.group45Min = 70
                                this.group60Min = 93.5
                                this.group75Min = 117
                                this.group90Min = 140
                            }
                            if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                                // this.individual45Min = 120
                                // this.individual90Min = 240
                                // this.group45Min = 60
                                // this.group90Min = 120
                                this.individual15Min = 40
                                this.individual30Min = 80
                                this.individual45Min = 120
                                this.individual60Min = 160
                                this.individual75Min = 200
                                this.individual90Min = 240
                                this.group15Min = 20
                                this.group30Min = 40
                                this.group45Min = 60
                                this.group60Min = 80
                                this.group75Min = 100
                                this.group90Min = 120
                            }
                        }
                    })
                } else {
                    this.isSelectedFromViewAllClaims = true
                    
                    db.collection('clientsClaims').doc(this.idClientClaim).get()
                    .then(dataClientClaim => {
                        db.collection('usuarios').doc(dataClientClaim.data().clinician).get()
                        .then(userDoc => {
                            this.userData = userDoc.data()
                            this.programClinician = userDoc.data().program ? userDoc.data().program : ''
                        })
                    })
                }
            }
        })

        var year = new Date().getFullYear()
        for(var i = year - 30; i <= year + 10; i++) {
            this.optionsYears.push(i)
        }

        if(this.idClientClaim) {
            // console.log(this.idClientClaim)
            db.collection('clientsClaims').doc(this.idClientClaim).get()
            .then(dataClientClaim => {
                if(!dataClientClaim.data().client) {
                    // db.collection('clients').doc(dataClientClaim.data().client).get()
                    // .then(itemClient => {
                        // get client
                        var objClient = ''
                        // if(dataClientClaim.data().client) {
                        //     var codigo = itemClient.data().id ? ' (#' + itemClient.data().id + ')' : ''
                        //     objClient = itemClient.data()
                        //     objClient.label = itemClient.data().firstName + ' ' + itemClient.data().lastName + codigo
                        //     objClient.clientID = itemClient.data().id
                        //     objClient.id = itemClient.id
                        // }
                        
                        // /api/client-activity/list/clients-of-clinicians/:id
                        this.$http.get(`https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/client-activity/list/clients-of-clinicians/${dataClientClaim.data().clinician}`)
                        .then(res => {
                            // console.log(res.data)
                            this.optionsClientApi = res.data
                        })

                        if(dataClientClaim.data().clinician) {
                            db.collection('usuarios').doc(dataClientClaim.data().clinician).get()
                            .then(userDoc => {
                                if(userDoc.data().role === 'clinician-staff') {
                                    var idOwnerClinician = userDoc.data().dependency
                                    db.collection('usuarios').doc(idOwnerClinician).get()
                                    .then(userDocDep => {
                                        this.userData = userDoc.data()

                                        if(userDocDep.data().region.toLowerCase() === 'nyc' || userDocDep.data().region.toLowerCase() === 'bronx' || userDocDep.data().region.toLowerCase() === 'brooklyn' || userDocDep.data().region.toLowerCase() === 'manhattan' || userDocDep.data().region.toLowerCase() === 'queens' || userDocDep.data().region.toLowerCase() === 'staten island') {
                                            this.ammountRegionCalculated1 = 90
                                        } else {
                                            this.ammountRegionCalculated1 = 45
                                        }

                                        if(userDocDep.data().region.toLowerCase() === 'northeast' || userDocDep.data().region.toLowerCase() === 'central' || userDocDep.data().region.toLowerCase() === 'finger lakes' || userDocDep.data().region.toLowerCase() === 'western') {
                                            this.ammountRegionCalculated2 = 80
                                        } else {
                                            this.ammountRegionCalculated2 = 40
                                        }

                                        if(userDocDep.data().region.toLowerCase() === 'mid-hudson' || userDocDep.data().region.toLowerCase() === 'long island' || userDocDep.data().region.toLowerCase() === 'nyc' || userDocDep.data().region.toLowerCase() === 'bronx' || userDocDep.data().region.toLowerCase() === 'brooklyn' || userDocDep.data().region.toLowerCase() === 'manhattan' || userDocDep.data().region.toLowerCase() === 'queens' || userDocDep.data().region.toLowerCase() === 'staten island') {
                                            // this.individual45Min = 140
                                            // this.individual90Min = 280
                                            // this.group45Min = 70
                                            // this.group90Min = 140
                                            this.individual15Min = 47
                                            this.individual30Min = 94
                                            this.individual45Min = 140
                                            this.individual60Min = 187
                                            this.individual75Min = 234
                                            this.individual90Min = 280
                                            this.group15Min = 23.5
                                            this.group30Min = 47
                                            this.group45Min = 70
                                            this.group60Min = 93.5
                                            this.group75Min = 117
                                            this.group90Min = 140
                                        }
                                        if(userDocDep.data().region.toLowerCase() === 'northeast' || userDocDep.data().region.toLowerCase() === 'central' || userDocDep.data().region.toLowerCase() === 'finger lakes' || userDocDep.data().region.toLowerCase() === 'western') {
                                            // this.individual45Min = 120
                                            // this.individual90Min = 240
                                            // this.group45Min = 60
                                            // this.group90Min = 120
                                            this.individual15Min = 40
                                            this.individual30Min = 80
                                            this.individual45Min = 120
                                            this.individual60Min = 160
                                            this.individual75Min = 200
                                            this.individual90Min = 240
                                            this.group15Min = 20
                                            this.group30Min = 40
                                            this.group45Min = 60
                                            this.group60Min = 80
                                            this.group75Min = 100
                                            this.group90Min = 120
                                        }
                                    })
                                } else {
                                    this.userData = userDoc.data()

                                    if(userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                                        this.ammountRegionCalculated1 = 90
                                    } else {
                                        this.ammountRegionCalculated1 = 45
                                    }

                                    if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                                        this.ammountRegionCalculated2 = 80
                                    } else {
                                        this.ammountRegionCalculated2 = 40
                                    }

                                    if(userDoc.data().region.toLowerCase() === 'mid-hudson' || userDoc.data().region.toLowerCase() === 'long island' || userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                                        // this.individual45Min = 140
                                        // this.individual90Min = 280
                                        // this.group45Min = 70
                                        // this.group90Min = 140
                                        this.individual15Min = 47
                                        this.individual30Min = 94
                                        this.individual45Min = 140
                                        this.individual60Min = 187
                                        this.individual75Min = 234
                                        this.individual90Min = 280
                                        this.group15Min = 23.5
                                        this.group30Min = 47
                                        this.group45Min = 70
                                        this.group60Min = 93.5
                                        this.group75Min = 117
                                        this.group90Min = 140
                                    }
                                    if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                                        // this.individual45Min = 120
                                        // this.individual90Min = 240
                                        // this.group45Min = 60
                                        // this.group90Min = 120
                                        this.individual15Min = 40
                                        this.individual30Min = 80
                                        this.individual45Min = 120
                                        this.individual60Min = 160
                                        this.individual75Min = 200
                                        this.individual90Min = 240
                                        this.group15Min = 20
                                        this.group30Min = 40
                                        this.group45Min = 60
                                        this.group60Min = 80
                                        this.group75Min = 100
                                        this.group90Min = 120
                                    }
                                }
                            })
                        }

                        this.approvalStatus = dataClientClaim.data().approvalStatus
                        this.claimDateMonth = dataClientClaim.data().claimDateMonth
                        this.claimDateYear = dataClientClaim.data().claimDateYear
                        this.noIndividualSessions = dataClientClaim.data().noIndividualSessions
                        this.noGroupSessions = dataClientClaim.data().noGroupSessions
                        this.noRemoteSessions = dataClientClaim.data().noRemoteSessions
                        this.noRemoteSessionsReal = dataClientClaim.data().noRemoteSessions
                        this.noPhoneSessions = dataClientClaim.data().noPhoneSessions ? dataClientClaim.data().noPhoneSessions : ''
                        this.noVideoSessions = dataClientClaim.data().noVideoSessions ? dataClientClaim.data().noVideoSessions : ''
                        this.noAssessmentSessions = dataClientClaim.data().noAssessmentSessions ? dataClientClaim.data().noAssessmentSessions : ''
                        this.noCoupleSessions = dataClientClaim.data().noCoupleSessions ? dataClientClaim.data().noCoupleSessions : ''
                        this.noFamilySessions = dataClientClaim.data().noFamilySessions ? dataClientClaim.data().noFamilySessions : ''
                        this.clientInsurance = dataClientClaim.data().clientInsurance
                        this.isInsuranceUtilizedForClaim = dataClientClaim.data().isInsuranceUtilizedForClaim
                        // isInsuranceUtilizedForClaim = dataClientClaim.data().
                        this.insuranceReimbursementRateForIndividualSessions = dataClientClaim.data().insuranceReimbursementRateForIndividualSessions
                        this.insuranceReimbursementRateForGroupSessions = dataClientClaim.data().insuranceReimbursementRateForGroupSessions
                        this.insuranceReimbursementRateForRemoteSessions = dataClientClaim.data().insuranceReimbursementRateForRemoteSessions
                        // isInsuranceUtilizedForClaim = dataClientClaim.data().
                        this.ifNotUtilizingInsurance = dataClientClaim.data().ifNotUtilizingInsurance
                        this.ifNotUtilizingInsuranceResponseOther = dataClientClaim.data().ifNotUtilizingInsuranceResponseOther ? dataClientClaim.data().ifNotUtilizingInsuranceResponseOther : ''
                        this.clientProgressThisMonth = dataClientClaim.data().clientProgressThisMonth
                        this.clientReportsSatisfactionWithTreatmentSessions = dataClientClaim.data().clientReportsSatisfactionWithTreatmentSessions
                        // clientReportsSatisfactionWithTreatmentSessions = dataClientClaim.data().
                        this.ifNoReportsSatisfaction = dataClientClaim.data().ifNoReportsSatisfaction
                        this.didClientProvideCopay = dataClientClaim.data().didClientProvideCopay ? dataClientClaim.data().didClientProvideCopay : ''
                        this.copayAmount = dataClientClaim.data().copayAmount ? dataClientClaim.data().copayAmount : ''
                        this.didClientUtilizeSlidingScale = dataClientClaim.data().didClientUtilizeSlidingScale ? dataClientClaim.data().didClientUtilizeSlidingScale : ''
                        this.amount = dataClientClaim.data().amount ? dataClientClaim.data().amount : ''
                        this.amountBilledToCFE = dataClientClaim.data().amountBilledToCFE
                        this.notes = dataClientClaim.data().notes
                        this.client = objClient
                        this.dateOfBirthPGRCOASASProgram = dataClientClaim.data().dateOfBirthPGRCOASASProgram ? dataClientClaim.data().dateOfBirthPGRCOASASProgram : ''
                        this.sexAtBirth = dataClientClaim.data().sexAtBirth ? dataClientClaim.data().sexAtBirth : ''
                        this.last4SSN = dataClientClaim.data().last4SSN ? dataClientClaim.data().last4SSN : ''
                        this.firstTwoLettersLastName = dataClientClaim.data().firstTwoLettersLastName ? dataClientClaim.data().firstTwoLettersLastName : ''
                        this.itemsFormRepeater = dataClientClaim.data().itemsFormRepeater ? dataClientClaim.data().itemsFormRepeater : []
                        this.counterSession()
                    // })
                } else {
                    db.collection('clients').doc(dataClientClaim.data().client).get()
                    .then(itemClient => {
                        // get client
                        var objClient = ''
                        if(dataClientClaim.data().client) {
                            var codigo = itemClient.data().id ? ' (#' + itemClient.data().id + ')' : ''
                            objClient = itemClient.data()
                            objClient.label = itemClient.data().firstName + ' ' + itemClient.data().lastName + codigo
                            objClient.clientID = itemClient.data().id
                            objClient.id = itemClient.id
                        }
                        
                        // /api/client-activity/list/clients-of-clinicians/:id
                        this.$http.get(`https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/client-activity/list/clients-of-clinicians/${dataClientClaim.data().clinician}`)
                        .then(res => {
                            // console.log(res.data)
                            this.optionsClientApi = res.data
                        })

                        if(dataClientClaim.data().clinician) {
                            db.collection('usuarios').doc(dataClientClaim.data().clinician).get()
                            .then(userDoc => {
                                if(userDoc.data().role === 'clinician-staff') {
                                    var idOwnerClinician = userDoc.data().dependency
                                    db.collection('usuarios').doc(idOwnerClinician).get()
                                    .then(userDocDep => {
                                        this.userData = userDoc.data()

                                        if(userDocDep.data().region.toLowerCase() === 'nyc' || userDocDep.data().region.toLowerCase() === 'bronx' || userDocDep.data().region.toLowerCase() === 'brooklyn' || userDocDep.data().region.toLowerCase() === 'manhattan' || userDocDep.data().region.toLowerCase() === 'queens' || userDocDep.data().region.toLowerCase() === 'staten island') {
                                            this.ammountRegionCalculated1 = 90
                                        } else {
                                            this.ammountRegionCalculated1 = 45
                                        }

                                        if(userDocDep.data().region.toLowerCase() === 'northeast' || userDocDep.data().region.toLowerCase() === 'central' || userDocDep.data().region.toLowerCase() === 'finger lakes' || userDocDep.data().region.toLowerCase() === 'western') {
                                            this.ammountRegionCalculated2 = 80
                                        } else {
                                            this.ammountRegionCalculated2 = 40
                                        }

                                        if(userDocDep.data().region.toLowerCase() === 'mid-hudson' || userDocDep.data().region.toLowerCase() === 'long island' || userDocDep.data().region.toLowerCase() === 'nyc' || userDocDep.data().region.toLowerCase() === 'bronx' || userDocDep.data().region.toLowerCase() === 'brooklyn' || userDocDep.data().region.toLowerCase() === 'manhattan' || userDocDep.data().region.toLowerCase() === 'queens' || userDocDep.data().region.toLowerCase() === 'staten island') {
                                            // this.individual45Min = 140
                                            // this.individual90Min = 280
                                            // this.group45Min = 70
                                            // this.group90Min = 140
                                            this.individual15Min = 47
                                            this.individual30Min = 94
                                            this.individual45Min = 140
                                            this.individual60Min = 187
                                            this.individual75Min = 234
                                            this.individual90Min = 280
                                            this.group15Min = 23.5
                                            this.group30Min = 47
                                            this.group45Min = 70
                                            this.group60Min = 93.5
                                            this.group75Min = 117
                                            this.group90Min = 140
                                        }
                                        if(userDocDep.data().region.toLowerCase() === 'northeast' || userDocDep.data().region.toLowerCase() === 'central' || userDocDep.data().region.toLowerCase() === 'finger lakes' || userDocDep.data().region.toLowerCase() === 'western') {
                                            // this.individual45Min = 120
                                            // this.individual90Min = 240
                                            // this.group45Min = 60
                                            // this.group90Min = 120
                                            this.individual15Min = 40
                                            this.individual30Min = 80
                                            this.individual45Min = 120
                                            this.individual60Min = 160
                                            this.individual75Min = 200
                                            this.individual90Min = 240
                                            this.group15Min = 20
                                            this.group30Min = 40
                                            this.group45Min = 60
                                            this.group60Min = 80
                                            this.group75Min = 100
                                            this.group90Min = 120
                                        }
                                    })
                                } else {
                                    this.userData = userDoc.data()

                                    if(userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                                        this.ammountRegionCalculated1 = 90
                                    } else {
                                        this.ammountRegionCalculated1 = 45
                                    }

                                    if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                                        this.ammountRegionCalculated2 = 80
                                    } else {
                                        this.ammountRegionCalculated2 = 40
                                    }

                                    if(userDoc.data().region.toLowerCase() === 'mid-hudson' || userDoc.data().region.toLowerCase() === 'long island' || userDoc.data().region.toLowerCase() === 'nyc' || userDoc.data().region.toLowerCase() === 'bronx' || userDoc.data().region.toLowerCase() === 'brooklyn' || userDoc.data().region.toLowerCase() === 'manhattan' || userDoc.data().region.toLowerCase() === 'queens' || userDoc.data().region.toLowerCase() === 'staten island') {
                                        // this.individual45Min = 140
                                        // this.individual90Min = 280
                                        // this.group45Min = 70
                                        // this.group90Min = 140
                                        this.individual15Min = 47
                                        this.individual30Min = 94
                                        this.individual45Min = 140
                                        this.individual60Min = 187
                                        this.individual75Min = 234
                                        this.individual90Min = 280
                                        this.group15Min = 23.5
                                        this.group30Min = 47
                                        this.group45Min = 70
                                        this.group60Min = 93.5
                                        this.group75Min = 117
                                        this.group90Min = 140
                                    }
                                    if(userDoc.data().region.toLowerCase() === 'northeast' || userDoc.data().region.toLowerCase() === 'central' || userDoc.data().region.toLowerCase() === 'finger lakes' || userDoc.data().region.toLowerCase() === 'western') {
                                        // this.individual45Min = 120
                                        // this.individual90Min = 240
                                        // this.group45Min = 60
                                        // this.group90Min = 120
                                        this.individual15Min = 40
                                        this.individual30Min = 80
                                        this.individual45Min = 120
                                        this.individual60Min = 160
                                        this.individual75Min = 200
                                        this.individual90Min = 240
                                        this.group15Min = 20
                                        this.group30Min = 40
                                        this.group45Min = 60
                                        this.group60Min = 80
                                        this.group75Min = 100
                                        this.group90Min = 120
                                    }
                                }
                            })
                        }

                        this.approvalStatus = dataClientClaim.data().approvalStatus
                        this.claimDateMonth = dataClientClaim.data().claimDateMonth
                        this.claimDateYear = dataClientClaim.data().claimDateYear
                        this.noIndividualSessions = dataClientClaim.data().noIndividualSessions
                        this.noGroupSessions = dataClientClaim.data().noGroupSessions
                        this.noRemoteSessions = dataClientClaim.data().noRemoteSessions
                        this.noRemoteSessionsReal = dataClientClaim.data().noRemoteSessions
                        this.noPhoneSessions = dataClientClaim.data().noPhoneSessions ? dataClientClaim.data().noPhoneSessions : ''
                        this.noVideoSessions = dataClientClaim.data().noVideoSessions ? dataClientClaim.data().noVideoSessions : ''
                        this.noAssessmentSessions = dataClientClaim.data().noAssessmentSessions ? dataClientClaim.data().noAssessmentSessions : ''
                        this.noCoupleSessions = dataClientClaim.data().noCoupleSessions ? dataClientClaim.data().noCoupleSessions : ''
                        this.noFamilySessions = dataClientClaim.data().noFamilySessions ? dataClientClaim.data().noFamilySessions : ''
                        this.clientInsurance = dataClientClaim.data().clientInsurance
                        this.isInsuranceUtilizedForClaim = dataClientClaim.data().isInsuranceUtilizedForClaim
                        // isInsuranceUtilizedForClaim = dataClientClaim.data().
                        this.insuranceReimbursementRateForIndividualSessions = dataClientClaim.data().insuranceReimbursementRateForIndividualSessions
                        this.insuranceReimbursementRateForGroupSessions = dataClientClaim.data().insuranceReimbursementRateForGroupSessions
                        this.insuranceReimbursementRateForRemoteSessions = dataClientClaim.data().insuranceReimbursementRateForRemoteSessions
                        // isInsuranceUtilizedForClaim = dataClientClaim.data().
                        this.ifNotUtilizingInsurance = dataClientClaim.data().ifNotUtilizingInsurance
                        this.ifNotUtilizingInsuranceResponseOther = dataClientClaim.data().ifNotUtilizingInsuranceResponseOther ? dataClientClaim.data().ifNotUtilizingInsuranceResponseOther : ''
                        this.clientProgressThisMonth = dataClientClaim.data().clientProgressThisMonth
                        this.clientReportsSatisfactionWithTreatmentSessions = dataClientClaim.data().clientReportsSatisfactionWithTreatmentSessions
                        // clientReportsSatisfactionWithTreatmentSessions = dataClientClaim.data().
                        this.ifNoReportsSatisfaction = dataClientClaim.data().ifNoReportsSatisfaction
                        this.didClientProvideCopay = dataClientClaim.data().didClientProvideCopay ? dataClientClaim.data().didClientProvideCopay : ''
                        this.copayAmount = dataClientClaim.data().copayAmount ? dataClientClaim.data().copayAmount : ''
                        this.didClientUtilizeSlidingScale = dataClientClaim.data().didClientUtilizeSlidingScale ? dataClientClaim.data().didClientUtilizeSlidingScale : ''
                        this.amount = dataClientClaim.data().amount ? dataClientClaim.data().amount : ''
                        this.amountBilledToCFE = dataClientClaim.data().amountBilledToCFE
                        this.notes = dataClientClaim.data().notes
                        this.client = objClient
                        this.dateOfBirthPGRCOASASProgram = dataClientClaim.data().dateOfBirthPGRCOASASProgram ? dataClientClaim.data().dateOfBirthPGRCOASASProgram : ''
                        this.sexAtBirth = dataClientClaim.data().sexAtBirth ? dataClientClaim.data().sexAtBirth : ''
                        this.last4SSN = dataClientClaim.data().last4SSN ? dataClientClaim.data().last4SSN : ''
                        this.firstTwoLettersLastName = dataClientClaim.data().firstTwoLettersLastName ? dataClientClaim.data().firstTwoLettersLastName : ''
                        this.itemsFormRepeater = dataClientClaim.data().itemsFormRepeater ? dataClientClaim.data().itemsFormRepeater : []
                        this.counterSession()
                    })
                }
            })
        }

        db.collection('taxonomies').doc('client').get()
        .then(docTaxonomia => {
            this.optionsInsuranceType = docTaxonomia.data().insuranceType
        })
    },
    mounted() {
        if(window.location.pathname.includes('users/edit/clinician')) {
            this.editClaimClinician = true
        }

        this.initTrHeight()

        if (window.history && window.history.pushState) {
            window.history.pushState('forward', null, '');

            window.addEventListener('popstate', () => {
                // alert('Back button was pressed.');
                this.statusEditClientClaim = false
                this.$emit('statusEditClientClaim',false)
            });
        }

        this.$emit('statusEditClientClaim',true)
        
        setTimeout(() => {
            this.calculateAmountBilledToCFE()
        }, 1500);
    },
    destroyed() {
        window.removeEventListener('resize', this.initTrHeight)
    },
}
</script>

<style>
.vs--disabled .vs__selected {
    color: #656b85 !important;
}
.mx-input:disabled {
    color: #000 !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>